var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.producer))]),_vm._v(" submitted an update to the "+_vm._s(_vm.resourceName)+", changing sources for "+_vm._s(_vm.summary)+": ")]),_c('div',{staticClass:"fields"},[_vm._v(" "+_vm._s(_vm.fields.join(', '))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }